import React from "react";

import { ROUTES_CYCLES_CONFIG } from "./config";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import RegularButton from "components/CustomButtons/Button";
import { blue } from "@mui/material/colors";
import { Box } from "@mui/material";

export const columns = [
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.route.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.route.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.route.key]
        ? row[ROUTES_CYCLES_CONFIG.route.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.paymentCycle.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.paymentCycle.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.paymentCycle.key]
        ? row[ROUTES_CYCLES_CONFIG.paymentCycle.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.facility.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.facility.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.facility.key]
        ? row[ROUTES_CYCLES_CONFIG.facility.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.employee.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.employee.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.employee.key]
        ? row[ROUTES_CYCLES_CONFIG.employee.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },

  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.cycle.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.cycle.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.cycle.key]
        ? row[ROUTES_CYCLES_CONFIG.cycle.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.start.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.start.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.start.key]
        ? row[ROUTES_CYCLES_CONFIG.start.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.end.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.end.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.end.key]
        ? row[ROUTES_CYCLES_CONFIG.end.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CYCLES_CONFIG.status.label}</span>,
    accessor: ROUTES_CYCLES_CONFIG.status.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CYCLES_CONFIG.status.key]
        ? row[ROUTES_CYCLES_CONFIG.status.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const handleOpenRoute = () => {
        original.modal(original.id);
      };
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            gap: "4"
          }}
        >
          <RegularButton
            tooltip="Abrir"
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={handleOpenRoute}
          >
            <CreateNewFolderIcon style={{ color: blue[500] }} />
          </RegularButton>
        </Box>
      );
    }
  }
];
